import { faAngleLeft, faEllipsisVertical, faHome } from '@fortawesome/pro-solid-svg-icons';
import { useLayoutEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';

import Button from '../../Atoms/Button';
import ButtonsContainer from '../../Atoms/ButtonsContainer';
import ActionsMenu from '../ActionsMenu';

import * as style from './style.module.css';

const HeaderBreadcrumb = ({ className = '', history = [], actions = [], t }) => {
    const [isMenuOpened, setIsMenuOpened] = useState(false);

    // Auto close if there is no options in actions menu
    useLayoutEffect(() => {
        (() => {
            if (isMenuOpened && actions.length === 0) {
                setIsMenuOpened(false);
            }
        })();
    }, [isMenuOpened, actions.length]);

    const previous = history[history.length - 2] || (history.length > 0 ? { title: t('Home'), icon: faHome, action: '/' } : null);
    const current = history[history.length - 1] || null;

    return (
        <>
            <div className={`${style.container} ${className}`}>
                <div className={style.left}>
                    {previous && <Button label={t('Back')} action={previous.action} icon={faAngleLeft} iconOnlyOnMobile />}
                </div>
                <div className={style.center}>
                    {current?.title}
                </div>
                <div className={style.right}>
                    {actions && <ButtonsContainer scrollable={false} noMargin>
                        {actions.length === 1 && <Button key={0} action={actions[0].action} icon={actions[0].icon} label={actions[0].label} loading={actions[0].loading || false} disabled={actions[0].disabled || false} iconOnlyOnMobile />}
                        {actions.length > 1 && <Button key={0} action={() => setIsMenuOpened(true)} icon={faEllipsisVertical} label={t('More actions')} iconOnlyOnMobile />}
                    </ButtonsContainer>}
                </div>
            </div>
            <ActionsMenu actions={actions.toReversed().map(e => ({ ...e, title: e.label }))} isOpened={isMenuOpened} onClose={() => setIsMenuOpened(false)} />
        </>
    );
};

export default withTranslation()(HeaderBreadcrumb);
